// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"382":"ja-JP-main-json","467":"zh-CN-main-json","589":"zh-TW-main-json","872":"en-US-main-json"}[chunkId] + "." + {"382":"0beed209","467":"9ffbd9af","589":"81a9ac2e","872":"b0987bf7"}[chunkId] + ".chunk.js";
};